import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';

import { SidebarModule } from './sidebar/sidebar.module';
import { FixedPluginModule } from './shared/fixedplugin/fixedplugin.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AppRoutes } from './app.routing';
import { AuthGuardService } from './guards/auth-guard.service'
import { AuthService } from './services/auth.service';
import { SharedDataService } from './services/shared-data.service'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Interceptor } from './layouts/auth/interceptor.module';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { DialogPolicyComponent } from './dialog-policy/dialog-policy.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MatDialogModule } from '@angular/material/dialog';

registerLocaleData(localePt);
@NgModule({
    imports:      [
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(AppRoutes, {
          useHash: true
        }),
        NgbModule,
        HttpModule,
        SidebarModule,
        HttpClientModule,
        NavbarModule,
        FooterModule,
        FixedPluginModule,
        NgxMatSelectSearchModule,
        Interceptor,
        PdfViewerModule
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        DialogPolicyComponent
    ],
    exports: [MatDialogModule],
    providers: [AuthService, AuthGuardService, SharedDataService, { provide: LOCALE_ID, useValue: 'pt'}],
    bootstrap:    [ AppComponent ]
})

export class AppModule { }
